import styled from 'styled-components'

export const BlogContainer = styled.div`
  margin: 2rem auto 0;
  width: 90%;
  max-width: 700px;
  padding: 20px 10px;
`